import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    audiences: {
        rowPerPage: 10,
        isDisplayed: true,
        sorting: [
            {
                key: 'id',
                orders: {
                    id: 'desc',
                    label: 'asc'
                }
            }
        ]
    },
    isFilterDisplayed: false,
    searchFilters: {
        input: null,
        active: null,
        migratable: true
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
